import { Iap, ProductId } from '.';
import {
  GemsProductId,
  productIds,
  stripeLivePrices,
  stripeTestPrices,
} from './iap.ruleset';
import { assertNever } from '../utils';

export const isProductId = (productId: string): productId is ProductId =>
  Iap.ruleset.productIds.includes(productId as ProductId);

export const isProductIdGems = (
  productId: ProductId,
): productId is GemsProductId => Iap.ruleset.gemsProductIds.includes(productId);

export const getProductRewards = (productId: ProductId) => {
  if (isProductIdGems(productId)) {
    return Iap.ruleset.gemsRewardTable[productId];
  }

  assertNever(productId);
};

/** Find out Stripe product price id by product id */
export function getStripePriceIdByProductId(
  productId: ProductId,
  liveMode = true,
) {
  if (!productIds.includes(productId)) {
    throw new Error('Unknown product: ' + productId);
  }

  if (liveMode) {
    return stripeLivePrices[productId];
  } else {
    return stripeTestPrices[productId];
  }
}
